import { Injectable } from '@angular/core';

@Injectable()

export class ResultControlInfoService {
  constructor() { }
  getResultProperties() {

    const resultProperties: Array<any>[] =
      [
        [
          {
            key: 'resultList', label: 'Result List', iterable: true, modal: false, required: false,
            items: [{ key: 'RTN', type: 'text' },
            { key: 'City/Town', type: 'text' },
            { key: 'Release Address', type: 'text' },
            { key: 'Zip Code', type: 'text' },
            { key: 'Site Name Location Aid', type: 'text' },
            { key: 'Reporting Category', type: 'text' },
            { key: 'Notification Date', type: 'text' },
            { key: 'Regulatory Status', type: 'text' },
            { key: 'Regulatory Date', type: 'text' },
            { key: 'Phase', type: 'text' },
            { key: 'RAO Class', type: 'text' },
            { key: 'Chemical Type', type: 'text' },
            { key: 'File', type: 'text' }]
          }
        ]
      ]
    return resultProperties;
  }
}
